<div fxLayout="column" style="width: 94vw">
    <div fxLayout="row" style="margin-top: 10px;">
        <ng-container *ngIf="consents.length > 0 then ShowConsents else ShowNoConsentsMessage"></ng-container>
    </div>
</div>


<ng-template #ShowConsents>
    <div fxLayout="column" [style.height.px]="listHeight" style="overflow: auto;">
        <div *ngFor="let item of consents" (click)="showConsent(item)" fxFlex="100" style="margin-top: 0.5rem; margin-bottom: 0.5rem; ">
            <div fxLayout="column" fxLayoutGap="10px">

                <div fxLayout="row" style="font-size: 16px; font-weight: 600;" class="mobile-list-item-title">{{item.formTitle}}</div>
                <div fxLayout="row" style="font-size: 12px;">{{item.description}}</div>

                <div fxLayout="row" style="font-size: 12px;">{{item.displayName}}</div>
                <div fxLayout="row" style="font-size: 12px;">Ημ. Δημοσίευσης: {{item.notificationDate}}</div>

                <div style="height: 1px; width: 100%; background-color: var(--secondaryBlue)"></div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #ShowNoConsentsMessage>
    <div fxLayout="column" style="width: 94vw;" [style.height.px]="listHeight" fxLayoutAlign="center center center">
        <label style="font-size: 18px; font-weight: 650">Δεν υπάρχουν διαθέσιμες δηλώσεις</label>
    </div>
</ng-template>
